var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getNotification && _vm.getNotification.setting_notification_bar)?_c('div',{staticClass:"bx-ribbon"},[_c('i',{staticClass:"la la-bullhorn text-white icon-lg mr-3"}),_vm._v(" "+_vm._s(_vm.getNotification.setting_notification_bar)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }